import { PolarArea } from 'vue-chartjs'

export default {
  extends: PolarArea,
  props: ['data', 'options'],
  mounted() {
    this.renderChart(this.data, this.options)
  },
  watch: {
    data() {
      this.renderChart(this.data, this.options)
    }
  }
}
